import type { PhieuChiCellValue, PhieuChiDetailRow, PhieuChiTaxRow } from '../types';
import type { PhieuChiInvoiceLookup } from '@/types/schemas';
import { roundNumber } from '@/lib/formatUtils';

/**
 * Calculate totals from detail rows and tax rows
 */
export const calculateTotals = (detailRows: PhieuChiDetailRow[] = [], taxRows: PhieuChiTaxRow[] = []) => {
  // Calculate total amount from detail rows
  const tongTien = detailRows.reduce((sum, row) => sum + (Number(row.tien_nt) || 0), 0);

  // Calculate total tax from both detail rows and tax rows
  const tongThueFromDetail = detailRows.reduce((sum, row) => sum + (Number(row.thue_nt) || 0), 0);

  const tongThueFromTax = taxRows.reduce((sum, row) => sum + (Number(row.t_thue_nt) || 0), 0);

  const tongThue = tongThueFromDetail + tongThueFromTax;

  // Calculate total payment (amount + tax)
  const tongThanhToan = tongTien + tongThue;

  return {
    tongTien: roundNumber(tongTien, 4),
    tongThue: roundNumber(tongThue, 4),
    tongThanhToan: roundNumber(tongThanhToan, 4)
  };
};

export const handleUpdateRowFields = (
  row: PhieuChiDetailRow | PhieuChiTaxRow,
  field: string,
  newValue: PhieuChiCellValue
) => {
  if (field === 'id_hd_data' || field === 'ma_thue_data' || field === 'tien_nt') {
    const invoiceValue =
      typeof newValue === 'object' && newValue && 'tien_tren_hd' in newValue
        ? (newValue as PhieuChiInvoiceLookup)
        : null;
    const taxValue = typeof newValue === 'object' && newValue && 'thue_suat' in newValue ? newValue : null;
    const tien_nt =
      Number(field === 'id_hd_data' ? invoiceValue?.tien_tren_hd : field === 'tien_nt' ? newValue : row.tien_nt) || 0;
    const thue_suat = Number(field === 'ma_thue_data' ? taxValue?.thue_suat : row.thue_suat) || 0;
    const thue_nt = roundNumber((tien_nt * thue_suat) / 100, 4);
    return {
      tien_nt: roundNumber(tien_nt, 4),
      thue_suat: roundNumber(thue_suat, 4),
      thue_nt
    };
  }
  return {};
};
